import types from './types';

export const setCurrentFolioNumber = (folioNumber: number) => ({
  payload: folioNumber,
  type: types.SET_CURRENT_FOLIO_NUMBER,
});
